import React, {useState, useEffect} from "react";
import cross from "../../../assets/misc/Cross.svg";
import first from "../../../assets/misc/first.svg";
import second from "../../../assets/misc/second.svg";
import third from "../../../assets/misc/third.svg";
import star from "../../../assets/misc/star.svg";
import Button from "../../common/Button";
import "./index.css";
import maximize from "../../../assets/misc/maximize.png";
import minimize from "../../../assets/misc/minimize.png";
import Misc from "../../../assets/misc/15.svg";
import Misc1 from "../../../assets/misc/16.svg";
import Misc2 from "../../../assets/misc/17.svg";


const getRank = (rank, score = null, scale) => {
    if((score > 0 && rank < 4) || score === null){
        if(rank == 1) return <img src={first} alt="" className={"-ml-1" + (scale==="large" ? " sm:h-[3rem] h-[2rem]" : " sm:min-w-[1.5rem] min-w-[1.25rem]")}/>
        else if(rank == 2) return <img src={second} alt="" className={"-ml-1" + (scale==="large" ? " sm:h-[3rem] h-[2rem]" : " sm:min-w-[1.5rem] min-w-[1.25rem]")}/>
        else if(rank == 3) return <img src={third} alt="" className={"-ml-1" + (scale==="large" ? " sm:h-[3rem] h-[2rem]" : " sm:min-w-[1.5rem] min-w-[1.25rem]")}/>
    }
    else return <p className="pl-[2px] sm:pl-[2px]">{rank}</p>;    
}

export const Leaderboard = (
    {setShowLeaderboard,
    showLeaderboard,
    teamData,
    firstStudent,
    firstFemale }) => {

    const [expand, setExpand] = useState(false);

    return (
        <div className={"w-screen h-[125vh] bg-black bg-opacity-30 fixed top-0 left-0 z-[100] overflow-hidden " + 
            (showLeaderboard == 1 ? " appear pointer-events-auto" : showLeaderboard == 0 ? " dissapear pointer-events-none" : " hidden")}>
            <div className="bg-white fixed max-w-[840px] w-[95vw] h-[95vh] max-h-[860px] rounded-[32px] opacity-100 bg-opacity-100 -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
                <div className="frame sm:p-8 p-6 flex flex-col">
                    <div className="flex justify-between items-start ">
                        <div className={"flex flex-col smooth " + (expand ? " dissapear h-0 overflow-clip" : " appear" )}>
                            <p className="font-semibold text-xs sm:text-sm text-warning uppercase mb-2">Top 5</p>
                            <p className="relative">
                                <span className="inline-flex w-full max-w-[288px] font-semibold lg:text-3xl md:text-2xl sm:text-xl text-lg leading-tight text-dark">
                                    Teams
                                </span>
                                <img
                                    src={Misc}
                                    className="absolute -right-5 -top-5 w-8 sm:w-9 md:w-auto"
                                    alt=":( Not Found"
                                />
                            </p>
                        </div>
                        <img src={cross} alt="" className=" select-none m-2 max-w-[91px] w-4 cursor-pointer" onClick={() => setShowLeaderboard(0)}/>
                    </div>
                    <div className={"flex flex-wrap justify-between text-center w-full  " + (expand ? " dissapear mt-0 h-0 overflow-clip" : " mt-4 sm:mt-6 appear" )}>
                        {teamData.slice(0, 3).map((team, index) => 
                            <div className={"flex flex-col m-0 px-1 items-center text-center max-w-[20%] w-[20%] smooth " + (expand ? " dissapear h-0 overflow-clip" : " appear" )}
                                key={index + "tag"}>
                                <div className=" sm:text-sm text-xs text-warning font-semibold rounded-2xl teamTag h-14 w-14 sm:h-[80px] sm:w-[80px] flex justify-center align-middle items-center">
                                    <div className="flex justify-center items-center pl-1">{getRank(index + 1, null, "large")}</div>
                                </div>
                                <p className="text-xxs sm:text-xs md:text-sm font-normal mt-3 break-all">{team.score > 0 ? team.team_name : "--"}</p>
                                {/* <p className="text-xxs sm:text-xs md:text-sm font-medium">{team.score > 0 && (team.score.toString().substring(0,team.score.toString().indexOf(".")+3)  + "%")}</p> */}
                                <p className="text-xxs sm:text-xs md:text-sm font-normal">{team.score > 0 && team.country}</p>
                            </div>
                        )}

                        <div className={"flex flex-col m-0 px-1 items-center text-center max-w-[20%] w-[20%] smooth " + (expand ? " dissapear h-0 overflow-clip" : " appear" )}
                            key="firstStudentTag">
                            <div className=" sm:text-sm text-xs text-warning font-semibold rounded-2xl teamTag h-14 w-14 sm:h-[80px] sm:w-[80px] flex justify-center align-middle items-center">
                                <div className="text-warning sm:text-xs text-xxs font-semibold">All<br/>Student</div>
                            </div>
                            <p className="text-xxs sm:text-xs md:text-sm font-normal mt-3 break-all">{firstStudent.score > 0 ? firstStudent.team_name : "--"}</p>
                            {/* <p className="text-xxs sm:text-xs md:text-sm font-medium">{firstStudent.score > 0 && (firstStudent.score.toString().substring(0,firstStudent.score.toString().indexOf(".")+3)  + "%")}</p> */}
                            <p className="text-xxs sm:text-xs md:text-sm font-normal">{firstStudent.score > 0 && firstStudent.country}</p>
                        </div>

                        <div className={"flex flex-col m-0 px-1 items-center text-center max-w-[20%] w-[20%] smooth " + (expand ? " dissapear h-0 overflow-clip" : " appear" )}
                            key="firstFemaleTag">
                            <div className=" sm:text-sm text-xs text-warning font-semibold rounded-2xl teamTag h-14 w-14 sm:h-[80px] sm:w-[80px] flex justify-center align-middle items-center">
                                <div className="text-warning sm:text-xs text-xxs font-semibold">All<br/>Female</div>
                            </div>
                            <p className="text-xxs sm:text-xs md:text-sm font-normal mt-3 break-all">{firstFemale.score > 0 ? firstFemale.team_name : "--"}</p>
                            {/* <p className="text-xxs sm:text-xs md:text-sm font-medium">{firstFemale.score > 0 && (firstFemale.score.toString().substring(0,firstFemale.score.toString().indexOf(".")+3)  + "%")}</p> */}
                            <p className="text-xxs sm:text-xs md:text-sm font-normal">{firstFemale.score > 0 && firstFemale.country}</p>
                        </div>
                    </div>
                    <div className={"flex justify-between relative smooth " + (expand ? " mt-0" : " mt-6 sm:mt-8 md:mt-10" )}>
                        <div className=" ">
                            <p className="font-semibold sm:text-sm text-xs text-warning uppercase mb-2">Leaderboard</p>
                            <span className="w-full font-semibold flex lg:text-3xl md:text-2xl sm:text-xl text-lg leading-tight text-dark sm:whitespace-nowrap">
                                Team in the order of their score
                                
                            </span>
                        </div>
                        <div className="flex items-center ml-4">
                            <img
                                className="md:mx-3 mx-2 cursor-pointer sm:h-5 h-4 mt-auto sm:mb-2 mb-1 appear"
                                onClick={() => setExpand(!expand)}
                                src={expand ? minimize : maximize}
                                alt="expand"
                            />
                        </div>
                    </div>
                    <div className="rounded-2xl bg-white mt-4 sm:px-4 px-1 pb-2 overflow-y-auto overflow-x-clip customScroll -mx-4 sm:mx-0 smooth">
                        <table className="table-auto w-full mb-5 border-separate " cellSpacing={0} cellPadding={0}>
                            <thead className="sticky top-0 z-10 bg-white">
                                <tr className=" borderedRow text-xs sm:text-sm border-opacity-40 leading-6 font-medium  text-[#142038]">
                                    <td className=" pt-4 px-2 sm:pt-4 pb-3 w-[5%] sm:pl-3">#</td>
                                    <td className=" pt-4 px-2 sm:pt-4 pb-3 w-[30%] ">Name</td>
                                    <td className=" pt-4 px-2 sm:pt-4 pb-3 w-[40%]">Location</td>
                                    <td className=" pt-4 px-2 sm:pt-4 pb-3 w-[25%]">Score</td>
                                    {/* <td className=" pt-4 px-2 sm:pt-4 pb-3 w-[20%] whitespace-nowrap">Affiliation
                                        <img src={star} alt="" className=" ml-2 w-4 sm:w-5 -mt-2 inline-block"/>
                                    </td> */}
                                </tr>
                            </thead>
                            <tbody className="">
                                {teamData.map((team, index) => 
                                    team.score > 0 && <tr 
                                    className={"text-xxs sm:text-xs md:text-sm font-normal text-[#142038] text-opacity-80 bg-opacity-20 align-top " + (
                                        (team.all_female && team.all_students) ? " bg-[#00FF7F] border-[#00FF7F]" : team.all_female ? " bg-[#ff782c] border-[#ff782c]" : team.all_students ? " bg-[#2962ff] border-[#2962ff]" : "" )}
                                    key={index + "row"}>
                                        <td className="px-2 pt-3 pb-1 sm:pl-3 w-[5%] left-curved">{getRank(index + 1, team.score.toFixed(4))}</td>
                                        <td className="px-2 pt-3 pb-1 w-[30%] break-all">{team.team_name}</td>
                                        <td className="px-2 pt-3 pb-1 w-[40%] min-w-[60px] relative">
                                            <p className="absolute left-2 top-3 right-0 whitespace-nowrap overflow-hidden overflow-ellipsis pr-3">
                                                {team.location}
                                            </p>
                                        </td>
                                        <td className="px-2 pt-3 pb-1 w-[25%] min-w-[3rem] right-curved break">{team.score.toFixed(4)}</td>
                                        {/* <td className="px-2 py-2 w-[20%]">
                                            {team.all_students && <p>All Student</p>}
                                            {team.all_female && <p>All Female</p>}
                                            {!team.all_female && !team.all_students && <p className="pl-7">-</p>}
                                        </td> */}
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <p className="whitespace-nowrap font-semibold mt-5 mb-2">Affiliation<img src={star} alt="" className=" ml-2 w-4 sm:w-5 -mt-2 inline-block"/></p>
                        <div className="flex sm:text-xs text-xxs">
                            <div className="flex"><p className="sm:w-4 sm:h-4 w-3 h-3 bg-[#ff782c] bg-opacity-40 mr-2"/>All Female team</div>
                            <div className="flex"><p className="sm:w-4 sm:h-4 w-3 h-3 bg-[#2962ff] bg-opacity-30 mr-2 ml-4"/>All Student team</div>
                            <div className="flex"><p className="sm:w-4 sm:h-4 w-3 h-3 bg-[#00FF7F] bg-opacity-40 mr-2 ml-4"/>All Female & All Student team</div>
                        </div>
                    </div>
                    {/* <div className="w-full mt-auto pt-4 flex justify-center">
                        <Button  color = "success" className="w-full sm:w-auto whitespace-nowrap text-sm sm:text-base px-4 py-2 sm:py-4 sm:px-8">Open full leaderboard</Button>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export const LeaderboardHome = (
    {setShowLeaderboard,
    teamData,
    firstStudent,
    firstFemale }) => {
    
    // const [timeRemaining, setTimeRemaining] = useState("-- -- -- --");

    // useEffect(() => {
    //     let countDownDate = new Date("Nov 12, 2022 4:59:59").getTime();
    //     let difference = (new Date().getTimezoneOffset()) * 60 * 1000;

    //     var x = setInterval(function() {
    //         var now = new Date().getTime();
    //         now = now + difference;
    //         var distance = countDownDate - now;
            
    //         var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    //         var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    //         var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    //         var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            
    //         setTimeRemaining(days + "d " + hours + "h " + minutes + "m " + seconds + "s ");

    //         if (distance < 0) {
    //         clearInterval(x);
    //         setTimeRemaining("0d 00h 00m 00s");
    //         }
    //     }, 1000);

    //     return () => {
    //         clearInterval(x);
    //     }
    // })

    return (
    <div>
        <div className="flex flex-col justify-center align-middle items-center text-center">
            <span className="font-semibold text-xs sm:text-sm text-warning uppercase">Competition ended at</span>
            <div className="relative sm:pt-8 pt-6 sm:mb-11 mb-9 sm:w-80 w-60">
                <span className=" md:text-[40px] sm:text-4xl text-3xl md:leading-[48px] font-semibold text-[#142038] text-opacity-70 whitespace-nowrap">
                    {/* {timeRemaining} */}
                        11 Nov 11:59 PM ET
                </span>
                <img
                    src={Misc2}
                    className="absolute sm:-right-10 -right-6 sm:-bottom-6 -bottom-4 w-8 sm:w-9 md:w-auto"
                    alt=":( Not Found"
                />
            </div>
        </div>
        <div className=" mt-11 py-10 px-8 bg-white rounded-3xl flex flex-col">
            <div className="flex justify-between mb-4">
                <div className="flex flex-col mr-2">
                    <span className="font-semibold text-sm text-warning uppercase mb-2">Leaderboard</span>
                    <span className="w-full font-semibold lg:text-3xl md:text-2xl text-xl leading-tight text-dark sm:whitespace-nowrap">
                        Team in the order of their Score
                    </span>
                </div>
                <div className="flex items-center justify-center min-w-[60px] sm:w-auto max-w-[80px] md:max-w-[120px]">
                    <img
                        src={Misc1}
                        className=""
                        alt=":( Not Found"
                    />
                </div>
            </div>
            <div className="pb-5 border-dashed border-black border-b-[1px] border-opacity-40">
                <table className="table-auto w-full">
                    <thead className="sticky top-0 bg-white">
                        <tr className=" borderedRow text-xs sm:text-sm leading-6 font-medium text-[#142038]">
                            <td className=" pt-4 px-2 sm:pt-4 pb-3 w-[10%] sm:pl-3">#</td>
                            <td className=" pt-4 px-2 sm:pt-4 pb-3 w-[25%]">Name</td>
                            <td className=" pt-4 px-2 sm:pt-4 pb-3 w-[35%]">Location</td>
                            <td className=" pt-4 px-2 sm:pt-4 pb-3 w-[25%] whitespace-nowrap">Score
                                <img src={star} alt="" className=" ml-2 w-4 sm:w-5 -mt-2 inline-block"/>
                            </td>
                        </tr>
                    </thead>
                    <tbody className="">
                        {teamData?.slice(0, 3).map((team, index) => 
                            <tr className="text-xs sm:text-sm leading-6 font-normal text-[#142038] text-opacity-70 w-full align-top "  key={"outerRow" + index}>
                                <td className="px-2 pt-5 sm:pl-3 w-[10%]">{getRank(index + 1, team.score)}</td>
                                <td className="px-2 pt-5 min-w-[25%] w-[25%] break-words ">{team.score > 0 ? team.team_name : "--"}</td>
                                <td className="px-2 pt-5 w-[35%] min-w-[60px] relative">
                                    <p className="absolute left-2 top-5 right-0 whitespace-nowrap overflow-hidden overflow-ellipsis pr-3">
                                        {team.score > 0 ? team.location : "---" }
                                    </p>
                                </td>
                                <td className="px-2 pt-5 w-[25%] min-w-[60px] break ">{team.score > 0 ? team.score.toFixed(4) : "---" }</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div className="py-5 border-dashed border-black border-b-[1px] border-opacity-40">
                <span className="font-semibold text-sm text-warning uppercase mb-2">Top Student team</span>
                <table className="table-auto w-full">
                    <tbody>
                        <tr className="text-xs sm:text-sm leading-6 font-normal text-[#142038] text-opacity-70 w-full align-top "  key="topStudentRow">
                            <td className="px-2 pt-5 sm:pl-3 w-[10%]">{firstStudent?.rank || "-"}</td>
                            <td className="px-2 pt-5 min-w-[25%] w-[25%] break-words">{firstStudent?.team_name}</td>
                            <td className="px-2 pt-5 w-[35%] min-w-[60px] relative">
                                <p className="absolute left-2 top-5 right-0 whitespace-nowrap overflow-hidden overflow-ellipsis pr-3">
                                    {firstStudent?.location && firstStudent.location}
                                </p>
                            </td>
                            <td className="px-2 pt-5 w-[25%] min-w-[60px] break">
                                {firstStudent?.score > 0 ? firstStudent.score.toFixed(4) : "--"}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="pt-5">
                <span className="font-semibold text-sm text-warning uppercase mb-2">Top Female team</span>
                <table className="table-auto w-full">
                    <tbody>
                        <tr className="text-xs sm:text-sm leading-6 font-normal text-[#142038] text-opacity-70 w-full align-top "  key="topFemaleRow">
                            <td className="px-2 pt-5 sm:pl-3 w-[10%]">{firstFemale?.rank || "-"}</td>
                            <td className="px-2 pt-5 min-w-[25%] w-[25%] break-words">{firstFemale?.team_name}</td>
                            <td className="px-2 pt-5 w-[35%] min-w-[60px] relative">
                                <p className="absolute left-2 top-5 right-0 whitespace-nowrap overflow-hidden overflow-ellipsis pr-3">
                                    {firstFemale?.location && firstFemale.location}
                                </p>
                            </td>
                            <td className="px-2 pt-5 w-[25%] min-w-[60px] break">
                                {firstFemale?.score > 0 ? firstFemale.score.toFixed(4) : "--"}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="w-full mt-8 pt-4 flex justify-center">
                <Button
                    disabled={teamData && teamData[0]?.score > 0 ? false : true}
                    color = "success" className="w-full sm:w-auto whitespace-nowrap text-sm sm:text-base px-4 py-2 sm:py-4 sm:px-8"
                onClick={() => setShowLeaderboard(1)}>Open full leaderboard</Button>
            </div>
        </div>
    </div>   
    );
}

